import * as React from 'react';
import { NSpinner } from '@innersource-nn/novoui-react';

interface SpinnerProps {
    className?: string;
}
function Spinner({ className }: SpinnerProps) {
    return (
        <div
            className={`flex justify-center items-center ${className ?? 'h-dvh'}`}
        >
            <NSpinner color="blue" size="medium"></NSpinner>
        </div>
    );
}

export default Spinner;
